/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { pluginsUpdatePlugin } from "../funcs/pluginsUpdatePlugin.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { Plugin } from "../models/components/plugin.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  UpdatePluginRequest,
  UpdatePluginSecurity,
} from "../models/operations/updateplugin.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type UpdatePluginMutationVariables = {
  request: UpdatePluginRequest;
  security?: UpdatePluginSecurity | undefined;
  options?: RequestOptions;
};

export type UpdatePluginMutationData = Plugin;

export type UpdatePluginMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * updatePlugin plugins
 *
 * @remarks
 * Update plugin metadata.
 */
export function useUpdatePluginMutation(
  options?: MutationHookOptions<
    UpdatePluginMutationData,
    UpdatePluginMutationError,
    UpdatePluginMutationVariables
  >,
): UseMutationResult<
  UpdatePluginMutationData,
  UpdatePluginMutationError,
  UpdatePluginMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildUpdatePluginMutation(client, options),
    ...options,
  });
}

export function mutationKeyUpdatePlugin(): MutationKey {
  return ["@gram/client", "plugins", "updatePlugin"];
}

export function buildUpdatePluginMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: UpdatePluginMutationVariables,
  ) => Promise<UpdatePluginMutationData>;
} {
  return {
    mutationKey: mutationKeyUpdatePlugin(),
    mutationFn: function updatePluginMutationFn({
      request,
      security,
      options,
    }): Promise<UpdatePluginMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(pluginsUpdatePlugin(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
